import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/out/order/setting/remarktemplate/all', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/out/order/setting/remarktemplate/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/out/order/setting/remarktemplate/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/out/order/setting/remarktemplate/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/out/order/setting/remarktemplate/update', params,options);

export const up = (params, options) =>
  request.post('/api/v4ward/out/order/setting/remarktemplate/up', qs.stringify(params),options);

export const down = (params, options) =>
  request.post('/api/v4ward/out/order/setting/remarktemplate/down', qs.stringify(params),options);

  // /v4ward/out/order/setting/setting/getSubModuleList

export const getSubModuleList = (params, options) =>
request.get('/api/v4ward/order/execute/getSubModuleList', Object.assign({}, options, { params }))

export const getSubModuleListByOrderFlag = (params, options) =>
    request.get('/api/v4ward/order/execute/getSubModuleListByOrderFlag', Object.assign({}, options, { params }));